<script setup>
defineProps({
  open: Boolean,
  secondsLeft: {
    type: Number,
    default: 120,
  },
});

defineEmits(["extend", "logout"]);

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}
</script>

<template>
  <div v-if="open" class="session-modal-backdrop">
    <div class="session-modal-content" role="dialog" aria-modal="true">
      <div class="session-modal-icon">
        <span class="material-icons">access_time</span>
      </div>

      <h2>Session Expiring</h2>

      <p>You have been inactive for a while. Your session will expire in:</p>

      <div class="session-modal-countdown">
        {{ formatTime(secondsLeft) }}
      </div>

      <p class="session-modal-subtext">
        Click "Extend Session" to continue working.
      </p>

      <div class="session-modal-actions">
        <button class="btn bg-gradient-dark" @click="$emit('extend')">
          Extend Session
        </button>
        <button class="btn btn-outline-secondary" @click="$emit('logout')">
          Log Out
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.session-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.session-modal-content {
  background: white;
  border-radius: 12px;
  padding: 40px 32px 32px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.session-modal-icon {
  margin-bottom: 16px;
}

.session-modal-icon .material-icons {
  font-size: 48px;
  color: #f5a623;
}

h2 {
  margin: 0 0 12px;
  color: #333;
  font-size: 22px;
  font-weight: 600;
}

p {
  margin: 0 0 16px;
  color: #555;
  font-size: 15px;
  line-height: 1.5;
}

.session-modal-countdown {
  font-size: 52px;
  font-weight: 700;
  color: #e53935;
  letter-spacing: 2px;
  margin: 8px 0 16px;
  font-variant-numeric: tabular-nums;
}

.session-modal-subtext {
  font-size: 13px;
  color: #888;
  margin-bottom: 28px;
}

.session-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
</style>
